// extracted by mini-css-extract-plugin
export var link = "style-module--link--3HzN0";